import { ApolloLink } from '@apollo/client';

const log = false;

export const debugLink = new ApolloLink((operation, forward) => {
  if (import.meta.env.DEV && log) {
    console.log('🛰️ GraphQL:', operation.operationName);
    console.log('variables:', operation.variables);
    console.trace(); // here we can see the call stack leading to the GraphQL operation, which is useful for debugging
    // console.log(operation.query.loc?.source.body); // Uncomment to log the full GraphQL query, but be cautious as it can be very verbose
  }

  return forward(operation);
});
